// @flow

import React, { Component } from 'react'

import FolderIcon from '../Icons/icon-folder-grey.svg'
import ViewsIcon from '../Icons/icon-view-grey.svg'
import Loading from '../Icons/loading.gif'
import './TopFolders.css'

type Props = {
  data: Array,
  alt: string
}

/**
  * Diplay for top folders
  * @class
  * @extends Component
*/
class TopFolders extends Component<Props> {
  /** render function */
  render () {
    const folders = this.props.data.map((folder) => {
      if (folder.title === 'Loading') {
        return (<table key='Loading'><tbody><tr><td><img src={Loading} alt='Loading' /></td></tr></tbody></table>)
      } else {
        return (<div key={folder._id}>
          <div className='folderContent'>
            <div className='folderIcon'><img src={FolderIcon} alt='' /></div>
            <div className='contentBottom'>
              <p>{folder.title}</p>
              <span><img src={ViewsIcon} alt='' /> {folder.totalViews.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</span>
            </div>
          </div>
        </div>)
      }
    })
    if (this.props.alt === 'AdminDetails') {
      return (
        <div className='TopFolders box'>
          <h4 className='flex align-center space-between'>
            Last Folders Added
          </h4>
          <div className='folders'>{folders}</div>
        </div>
      )
    } else {
      return (
        <div className='TopFolders box'>
          <h4 className='flex align-center space-between'>
            Top Folders Viewed
          </h4>
          <div className='folders'>{folders}</div>
        </div>
      )
    }
  }
}

export default TopFolders
